import { render, staticRenderFns } from "./grupoVeiculosModelos.vue?vue&type=template&id=3a311fe6"
import script from "./grupoVeiculosModelos.vue?vue&type=script&lang=js"
export * from "./grupoVeiculosModelos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports